<div class="download-field-container">
      <a (click)="downloadActivityReport()"><i class="sch-download"></i></a>
</div>